export function formatBytes(n: number): string {
  if (!n) return "0 B";
  const u = ["B", "KB", "MB", "GB", "TB"];
  const i = Math.min(u.length - 1, Math.floor(Math.log(n) / Math.log(1024)));
  return `${(n / 1024 ** i).toFixed(i === 0 ? 0 : 1)} ${u[i]}`;
}

export function formatDate(ms: number | null | undefined): string {
  if (!ms) return "—";
  return new Date(ms).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
}

export function formatNumber(n: number | null | undefined): string {
  return (n ?? 0).toLocaleString();
}

/** 1 credit = US$0.01. */
export function creditsToUsd(credits: number): string {
  return (credits / 100).toLocaleString(undefined, { style: "currency", currency: "USD" });
}

export function centsToUsd(cents: number): string {
  return (cents / 100).toLocaleString(undefined, { style: "currency", currency: "USD" });
}

export function duration(start: number | null, end: number | null): string {
  if (!start) return "—";
  const s = Math.max(0, Math.round(((end ?? Date.now()) - start) / 1000));
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  return m < 60 ? `${m}m ${s % 60}s` : `${Math.floor(m / 60)}h ${m % 60}m`;
}

export const RETENTION_LABELS: Record<string, string> = {
  transit: "Transit only",
  "1m": "1 month",
  "3m": "3 months",
  "6m": "6 months",
  "12m": "12 months",
  forever: "Forever",
};

export const KIND_LABELS: Record<string, string> = { csv: "CSV file", klaviyo: "Klaviyo", mailchimp: "Mailchimp", shopify: "Shopify" };

export const RUN_KIND_LABELS: Record<string, string> = { dryrun: "Dry run", apply: "Run", revert: "Revert", stage: "Stage" };
